export function resolveChatContentHeight(args) {
  const {
    isDialogStylesEmpty,
    isExpandedInput
  } = args;
  if (!isDialogStylesEmpty) {
    return isExpandedInput ? 'calc(100% - 115px)' : 'calc(100% - 133px)';
  }
  return 'calc(100% - 120px)';
}
export function resolveChatContentStyle(args) {
  const {
    isDialogStylesEmpty,
    dialogStyles,
    standaloneStyles
  } = args;
  return !isDialogStylesEmpty ? dialogStyles : standaloneStyles;
}